import { createReducer } from "typesafe-actions"
import * as act from "../actions/OrderSheetsActions"
import { Throwing } from "../../models/common"
import { OrderSheetData, OrderSheetItemData } from "../../api/models/OrderSheetData"
import { containsSameProduct } from "../../Auth/Common"
import { LocalStorageWrapper } from "../../LocalStorage/LocalStorageWrapper";

interface OrderSheetsState extends Throwing {
    isBusy: boolean,
    orderSheets: OrderSheetData[] | null,
    currentOrderSheet: OrderSheetData | null,
    currOrderSheetDirty: boolean,
    updateOrderSheetBusy: boolean
}

const initialState: OrderSheetsState = {
    isBusy: false,
    orderSheets: null,
    currentOrderSheet: null,
    currOrderSheetDirty: false,
    updateOrderSheetBusy: false
}


const orderSheetsReducer = createReducer(initialState)
    .handleAction(act.getOrderSheetsAsync.request, (state) => { return { ...state, isBusy: true } })
    .handleAction(act.getOrderSheetsAsync.success, (state, action) => {
        let currOrderSheetId = LocalStorageWrapper.Get("current_order_sheet") !== null ? parseInt(LocalStorageWrapper.Get("current_order_sheet")!) : null
        let currOrderSheet: OrderSheetData | null = (currOrderSheetId === null ? action.payload[0] : action.payload.find(os => os.id === currOrderSheetId)) || null

        return { ...state, isBusy: false, orderSheets: action.payload, currentOrderSheet: currOrderSheet } //|| { name: 'My new order sheet', items: [] }
    })
    .handleAction(act.getOrderSheetsAsync.failure, (state, action) => { return { ...state, isBusy: false, error: action.payload } })

    .handleAction(act.updateOrderSheetAsync.request, (state) => { return { ...state, updateOrderSheetBusy: true } })
    .handleAction(act.updateOrderSheetAsync.success, (state, action) => {
        let orderSheets = state.orderSheets!.slice()
        orderSheets = orderSheets.filter((os) => os.id !== action.payload.id)
        orderSheets.push(action.payload)
        orderSheets.sort((a,b) => (a.name > b.name) ? 1 : -1)

        return { ...state, updateOrderSheetBusy: false, orderSheets: orderSheets, currentOrderSheet: action.payload, currOrderSheetDirty: false }
    })
    .handleAction(act.updateOrderSheetAsync.failure, (state, action) => { return { ...state, updateOrderSheetBusy: false, error: action.payload } })


    .handleAction(act.addOrderItem, (state, action) => {
        if (state.currentOrderSheet !== null) {
            let currOrderSheet = JSON.parse(JSON.stringify(state.currentOrderSheet)) as OrderSheetData
            if (!containsSameProduct(currOrderSheet.items, action.payload))
                currOrderSheet.items.push(action.payload)

            return { ...state, currentOrderSheet: currOrderSheet, currOrderSheetDirty: true }
        }

        return { ...state }
    })
    .handleAction(act.removeOrderItem, (state, action) => {
        if (state.currentOrderSheet !== null) {
            let currOrderSheet = JSON.parse(JSON.stringify(state.currentOrderSheet)) as OrderSheetData
            currOrderSheet.items = currOrderSheet.items.filter((p) => OrderSheetItemData.getSignature(p) !== OrderSheetItemData.getSignature(action.payload))
            return { ...state, currentOrderSheet: currOrderSheet, currOrderSheetDirty: true }
        }
        else
            return { ...state }

    })
    .handleAction(act.changeItemQuantity, (state, action) => {
        if (state.currentOrderSheet !== null) {

            let osIndex = state.orderSheets!.findIndex(os => os.id === state.currentOrderSheet!.id)
            if(osIndex >= 0){
                let items = updateObjectInArray(state.currentOrderSheet.items, action)
                let os = {...state.orderSheets![osIndex], items: items }
                let orderSheets = state.orderSheets!.slice()
                orderSheets[osIndex] = os

                return { ...state, currentOrderSheet: os, orderSheets: orderSheets}
            }
            else
                throw new Error("Internal application error.")
        }
        
        return { ...state }
    })

    .handleAction(act.setCurrentOrderSheet, (state, action) => {
        let current = state.orderSheets!.find((os) => os.id === action.payload)
        if (current === undefined)
            throw Error("Can't find requested Order Sheet")

        LocalStorageWrapper.Set("current_order_sheet", current.id.toString())
        return { ...state, currentOrderSheet: current }
    })

function updateObjectInArray(array: OrderSheetItemData[], action: any): OrderSheetItemData[] {
    return array.map((item, index) => {
        if (OrderSheetItemData.getSignature(item) !== OrderSheetItemData.getSignature(action.payload)) {
            return item
        }
        else
            return {
                ...item,
                ...action.payload
            }
    })
}

export default orderSheetsReducer;